import React from 'react'

import { Tooltip, TooltipSize } from '@octane/spark'
import { useBrandConfig } from 'contexts/BrandConfigContextProvider'
import { SUPPORT_PHONE } from 'utils/consts/contactInfo'
import { formatPhoneNumber } from 'utils/formatPhoneNumber'

import { MainText, PhoneNumber, Wrapper } from './CustomerAgent.styled'

interface CustomerAgentProps {
    agentName?: string
    phoneNumber?: string
    extension?: string
}

export default function CustomerAgent({
    agentName,
    phoneNumber,
    extension,
}: Readonly<CustomerAgentProps>): JSX.Element {
    const { navbarForceWhite } = useBrandConfig()

    if (!agentName || !phoneNumber) {
        return (
            <Wrapper data-testid="customer-agent">
                <MainText isWhiteVersion={navbarForceWhite}>
                    Call us! Credit Ops
                </MainText>
                <PhoneNumber
                    isWhiteVersion={navbarForceWhite}
                    data-dd-privacy="mask"
                >
                    {SUPPORT_PHONE}
                </PhoneNumber>
            </Wrapper>
        )
    }

    const agentText = `Call us! Your rep is ${agentName}`
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber)
    const extensionText = extension ? `ext. ${extension}` : ''

    const toolTipText = [agentText, formattedPhoneNumber, extensionText]
        .filter(Boolean)
        .join(' ')

    return (
        <Tooltip showOnHover size={TooltipSize.AUTO} position="bottom">
            <Tooltip.Trigger>
                <Wrapper data-testid="customer-agent">
                    <MainText
                        isWhiteVersion={navbarForceWhite}
                        data-dd-privacy="mask"
                    >
                        {agentText}
                    </MainText>
                    <PhoneNumber
                        isWhiteVersion={navbarForceWhite}
                        data-dd-privacy="mask"
                    >
                        {formattedPhoneNumber} {extensionText}
                    </PhoneNumber>
                </Wrapper>
            </Tooltip.Trigger>
            <Tooltip.Content>
                <Tooltip.Text data-dd-privacy="mask">
                    {toolTipText}
                </Tooltip.Text>
            </Tooltip.Content>
        </Tooltip>
    )
}
